import React from 'react';
import "./component.css";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

const TagpaySeriesComponent = (props) => {
  return (
    <div className="form-row">
      <Box className="form-field">
        <TextField 
          fullWidth 
          label="Corporate ID" 
          name="corporate_id"
          value={props.createTagSeriesData.corporate_id}
          onChange={props.handleChangeTagSeries}
        />
      </Box>
      <Box className="form-field">
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={props.createTagSeriesData.description}
          onChange={props.handleChangeTagSeries}
        />
      </Box>
      <Box className="form-field">
        <TextField
          fullWidth
          label="Code"
          name="code"
          value={props.createTagSeriesData.code}
          onChange={props.handleChangeTagSeries}
        />
      </Box>
      <Box className="form-field">
        <TextField
          fullWidth
          label="Initial Balance"
          name="initial_balance"
          value={props.createTagSeriesData.initial_balance}
          onChange={props.handleChangeTagSeries}
        />
      </Box>
    </div>
  );
};

export default TagpaySeriesComponent;